export enum GLRenderStage {
    BACKGROUND,
    FOREGROUND
}

export default GLRenderStage;
